exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".el-carousel.el-carousel--horizontal{border-radius:20px;height:349px}.el-carousel__item{height:349px!important}", "", {"version":3,"sources":["D:/pr/教育培训prod-PC/src/pages/webMall/index/banner.vue"],"names":[],"mappings":"AACA,qCACE,mBAAoB,AACpB,YAAa,CACd,AACD,mBACE,sBAAwB,CACzB","file":"banner.vue","sourcesContent":["\n.el-carousel.el-carousel--horizontal {\n  border-radius: 20px;\n  height:349px;\n}\n.el-carousel__item {\n  height:349px !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-02834085","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/webMall/index/banner.vue
// module id = 2584
// module chunks = 32 37